export default __webpack_public_path__ + "static/media/Button_Disclosure_Up.f05bd132.svg";